import type { Measurements } from '../apps/web/src/utilities/performance.ts'

export class PerformanceResultEvent extends CustomEvent<Measurements> {
  constructor(measurements: Measurements) {
    super('e2e:performance:result', {
      detail: measurements,
    })
  }
}

/**
 * Just for testing if types for multiple custom event work correctly
 */
export class PerformanceErrorEvent extends CustomEvent<{ bla: string }> {
  constructor() {
    super('e2e:performance:error', {
      detail: {
        bla: 'blupp',
      },
    })
  }
}

export function createPerformanceResultEvent(measurements: Measurements) {
  return new PerformanceResultEvent(measurements)
}

declare global {
  interface Window {
    __isE2ETest__?: boolean
  }

  interface WindowEventMap {
    'e2e:performance:result': PerformanceResultEvent
    'e2e:performance:error': PerformanceErrorEvent
  }
}

/**
 * Check if the application is running in an e2e test environment.
 * Returns true if __isE2ETest__ is set to true in the window object.
 */
export function isE2ETest(
  window: Window
): window is Window & { __isE2ETest__: boolean } {
  return '__isE2ETest__' in window && window.__isE2ETest__ === true
}
